import React, { useState, createContext } from "react";

import { api } from "../../Services/Api";
import DragAndDrop from "../DragAndDrop";
import AddAnswer from "./AddAnswer";
import ItemAnswer from "./ItemAnswer";
import { Container, List } from "./styles";

export const AnswersContext = createContext();

function Answers({ answersList, onChange, onChangeMany, product }) {
  function handleAddNew(answer) {
    onChange([...answersList, answer]);
  }

  function handleRemove(answer) {
    const updated = answersList.filter((asw) => asw._id !== answer._id);
    onChange(updated);
  }

  function handleChangeQuestions(question) {
    const updated = answersList.map((asw) => {
      if (asw._id === question._id) return question;
      return asw;
    });
    onChange(updated);
  }

  function handleChangeManyProducts(products) {
    onChangeMany(products);
  }

  async function handleReorderQuestions(questionList) {
    try {
      onChange(questionList);
      await api.put(`menu/products/${product._id}/reorder-questions`, {
        orderedListId: questionList.map((question) => question._id),
      });
    } catch (err) {
      alert("Erro ao reordenar");
    }
  }

  return (
    <AnswersContext.Provider value={{ product }}>
      <Container>
        <DragAndDrop
          list={answersList}
          onUpdateList={handleReorderQuestions}
          ContainerToRender={List}
          ItemToRender={({ data }) => (
            <ItemAnswer
              onRemove={handleRemove}
              onChange={handleChangeQuestions}
              onChangeMany={handleChangeManyProducts}
              data={data}
            />
          )}
        />
        <AddAnswer onAdd={handleAddNew} />
      </Container>
    </AnswersContext.Provider>
  );
}

export default Answers;
